import React from 'react';
import { Link } from 'react-router-dom';
import { Boxes, ArrowRight } from 'lucide-react';

const BulkBuyBanner = () => {
  return (
    <section className="py-14 md:py-16" style={{ backgroundColor: '#0C0A09' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link
          to="/bulk"
          className="group relative block overflow-hidden rounded-lg border transition-all duration-300 hover:border-[#D4A373]"
          style={{
            backgroundColor: '#1A1513',
            borderColor: '#362B25',
            backgroundImage:
              'radial-gradient(circle at 15% 50%, rgba(212, 163, 115, 0.15) 0%, transparent 55%), radial-gradient(circle at 85% 30%, rgba(212, 163, 115, 0.08) 0%, transparent 50%)',
          }}
          data-testid="bulk-buy-banner"
        >
          {/* subtle grain */}
          <div
            className="absolute inset-0 opacity-[0.03] pointer-events-none"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
            }}
          />

          <div className="relative grid grid-cols-1 md:grid-cols-[auto_1fr_auto] items-center gap-6 md:gap-8 px-6 py-8 md:px-10 md:py-10">
            {/* Icon block */}
            <div
              className="hidden md:flex items-center justify-center w-20 h-20 rounded"
              style={{
                backgroundColor: 'rgba(212, 163, 115, 0.12)',
                border: '1px solid rgba(212, 163, 115, 0.35)',
              }}
            >
              <Boxes className="h-10 w-10" style={{ color: '#D4A373' }} strokeWidth={1.5} />
            </div>

            {/* Copy */}
            <div>
              <div
                className="inline-block px-3 py-1 rounded-full text-[10px] tracking-[0.25em] uppercase font-semibold mb-3"
                style={{
                  backgroundColor: 'rgba(212, 163, 115, 0.18)',
                  color: '#D4A373',
                  border: '1px solid rgba(212, 163, 115, 0.4)',
                }}
              >
                10-Vial Wholesale Packs
              </div>
              <h2
                className="text-3xl md:text-4xl lg:text-5xl font-medium leading-[1.05] mb-2"
                style={{ fontFamily: 'Playfair Display, serif', color: '#F7F3EE' }}
              >
                Buy in <span style={{ color: '#D4A373' }}>Bulk</span> & Save
              </h2>
              <p
                className="text-sm md:text-base max-w-xl"
                style={{ color: '#B5A79E' }}
              >
                Reta, Tirzepatide, Wolverine Stack, Glow and more — flat bulk
                prices on 10-vial packs of the same product.
              </p>
            </div>

            {/* CTA */}
            <div className="flex md:justify-end">
              <span
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full font-bold tracking-[0.15em] uppercase text-sm transition-transform group-hover:scale-[1.03]"
                style={{
                  backgroundColor: '#D4A373',
                  color: '#0C0A09',
                  boxShadow: '0 0 24px rgba(212, 163, 115, 0.4)',
                }}
              >
                Shop Bulk
                <ArrowRight className="h-4 w-4" strokeWidth={2.5} />
              </span>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default BulkBuyBanner;
